<script setup>
defineProps({
  countryCode: {
    type: String,
    default: '',
  },
  size: {
    type: String,
    default: 'md',
    validator: validatorSizes,
  },
})
</script>

<template>
  <div
    class="fib fis mr-2 overflow-hidden rounded-full bg-grey-200 shadow-sm"
    :class="[
      `fi-${countryCode.toLowerCase()}`,
      {
        'h-6 w-6': size === 'md',
        'h-4 w-4': size === 'sm',
      },
    ]"
  />
</template>
